// Fix 1: the buy button never goes quiet. Once the cart holds every chair of this kind
// that's in stock (for a one-off chair, the one chair), the main button and the black sticky
// bar say so and open the cart instead of asking Shopify for one more, which it refuses.
// While more are in stock, a tap adds another and the cart opens as usual. If an add fails
// for any other reason, the message also shows on the sticky bar, where the shopper tapped.
if (!customElements.get('mg-buy-button')) {
  customElements.define(
    'mg-buy-button',
    class MgBuyButton extends HTMLElement {
      connectedCallback() {
        const id = this.dataset.sectionId;
        this.form = document.getElementById(`product-form-${id}`);
        this.mainButton = document.getElementById(`ProductSubmitButton-${id}`);
        this.stickyBar = document.getElementById(`PdpStickyBar-${id}`);
        this.stickyButton = document.getElementById(`PdpStickyAtc-${id}`);
        if (!this.form || !this.mainButton) return;

        // "variantId:quantity," pairs. Stock lists only variants that can't be oversold.
        this.stock = this.parsePairs(this.dataset.stock);
        this.cartQuantities = this.parsePairs(this.dataset.cartQuantities);
        // Capture phase, so it runs before the form submits; the sticky bar clicks this button too.
        this.mainButton.addEventListener('click', (event) => this.onBuyClick(event), true);
        this.unsubscribers = [
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart()),
          subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.render())),
          subscribe(PUB_SUB_EVENTS.cartError, (event) => this.onCartError(event)),
        ];
        this.render();
      }

      disconnectedCallback() {
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      }

      parsePairs(text = '') {
        const pairs = new Map();
        for (const pair of text.split(',').filter(Boolean)) {
          const [variantId, quantity] = pair.split(':');
          pairs.set(variantId, (pairs.get(variantId) || 0) + Number(quantity));
        }
        return pairs;
      }

      get variantId() {
        return String(this.form.querySelector('[name="id"]')?.value);
      }

      get cartFull() {
        const inCart = this.cartQuantities.get(this.variantId) || 0;
        const stock = this.stock.get(this.variantId);
        return inCart > 0 && stock !== undefined && inCart >= stock;
      }

      onBuyClick(event) {
        if (!this.cartFull) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.openCart();
      }

      openCart() {
        this.hideStickyMessage();
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open(this.mainButton);
        else window.location = window.routes.cart_url;
      }

      async refreshCart() {
        const cart = await (await fetch(`${window.routes.cart_url}.js`)).json();
        this.cartQuantities = new Map();
        for (const item of cart.items) {
          const variantId = String(item.variant_id);
          this.cartQuantities.set(variantId, (this.cartQuantities.get(variantId) || 0) + item.quantity);
        }
        this.render();
      }

      async onCartError(event) {
        if (event.source !== 'product-form' || String(event.productVariantId) !== this.variantId) return;
        await this.refreshCart();
        const inCart = this.cartQuantities.get(this.variantId) || 0;
        if (inCart > 0) {
          // Shopify refused one more (stock changed, or the page was out of date): treat
          // what's in the cart as the limit and show the cart.
          this.stock.set(this.variantId, inCart);
          this.render();
          this.form.closest('product-form')?.handleErrorMessage();
          this.openCart();
        } else if (this.stickyBar?.classList.contains('is-visible')) {
          this.showStickyMessage(event.message || event.errors);
        }
      }

      showStickyMessage(text) {
        if (!text || !this.stickyBar) return;
        let message = this.stickyBar.querySelector('.pdp-sticky-bar__message');
        if (!message) {
          message = document.createElement('p');
          message.className = 'pdp-sticky-bar__message';
          message.setAttribute('role', 'alert');
          this.stickyBar.prepend(message);
        }
        message.textContent = text;
        message.hidden = false;
      }

      hideStickyMessage() {
        const message = this.stickyBar?.querySelector('.pdp-sticky-bar__message');
        if (message) message.hidden = true;
      }

      render() {
        const full = this.cartFull;
        const mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`) || this.mainButton;
        const label = mainButton.querySelector('span');
        if (label && !mainButton.hasAttribute('disabled')) {
          label.textContent = full ? this.dataset.labelInCart : this.dataset.labelAdd;
        }
        if (this.stickyButton) {
          this.stickyButton.textContent = full ? this.dataset.labelInCartShort : this.dataset.labelAdd;
          this.stickyButton.classList.toggle('mg-in-cart', full);
        }
        mainButton.classList.toggle('mg-in-cart', full);
      }
    }
  );
}
